import { UseFormReturn } from 'react-hook-form';
import { ControlledField, AutocompleteField } from 'remote/global';

interface Props {
  formInstance: UseFormReturn<any>;
  name: string;
  translationKey?: string;
  filteredVehicles: string[];
}
function VehicleSelectField(props: Props) {
  const { formInstance, filteredVehicles, name, ...rest } = props;
  const { control } = formInstance;

  return (
    <ControlledField
      control={control}
      name={name}
      render={(renderProps) => (
        <AutocompleteField
          {...renderProps}
          {...rest}
          field={{
            ...renderProps.field,
          }}
          options={filteredVehicles.map((value: string) => ({
            label: value,
            value,
          }))}
          fieldProps={{
            disableClearable: true,
          }}
        />
      )}
    />
  );
}

export default VehicleSelectField;
